import { render, staticRenderFns } from "./check.vue?vue&type=template&id=e89e5002&scoped=true"
import script from "./check.vue?vue&type=script&lang=js"
export * from "./check.vue?vue&type=script&lang=js"
import style0 from "./check.vue?vue&type=style&index=0&id=e89e5002&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89e5002",
  null
  
)

export default component.exports